module.exports = __webpack_public_path__ + "s/img/1@2x.a9ecc556.png";